<div class="register-page-container">
  <app-register class="z-index--1"></app-register>
  <app-circles-background class="circle-background"></app-circles-background>
</div>
